import { createContext } from 'react';
export const ToastServiceContext = createContext(null);
